import React from 'react';

// Same photo as before, now a real <img> (instead of a CSS background) so the
// browser finds it straight away. Both files are preloaded from public/index.html,
// which is why they live in public/ with fixed names.
//  - hero-home-v1.jpg   : full photo (tablets and desktop)
//  - hero-home-m-v1.jpg : the same photo pre-cropped to the part phones can show
//                         (<= 767px), so phones download about 20% less.
//  - hero-home-s-v1.webp: the same photo cropped to what a narrow phone (<= 430px)
//                         can show, as WebP (about 65 KB instead of 185 KB).
const HERO_SRC = `${process.env.PUBLIC_URL}/hero-home-v1.jpg`;
const HERO_SRC_MOBILE = `${process.env.PUBLIC_URL}/hero-home-m-v1.jpg`;
const HERO_SRC_NARROW = `${process.env.PUBLIC_URL}/hero-home-s-v1.webp`;

const HeroSection = () => {
  return (
    <section className="home-hero-banner position-relative overflow-hidden mb-md-0 mb-5">
      <picture>
        <source media="(max-width: 430px)" srcSet={HERO_SRC_NARROW} type="image/webp" />
        <source media="(max-width: 767px)" srcSet={HERO_SRC_MOBILE} />
        <img
          className="home-hero-img"
          src={HERO_SRC}
          alt=""
          width="1672"
          height="941"
          fetchpriority="high"
          decoding="sync"
        />
      </picture>
    </section>
  );
};

export default HeroSection;
